import styles from "./ConfirmSendMessagePopup.module.scss";
import React from "react";
import confirmIcon from "../../../assets/images/icons/confirm-message.svg";
import {useTranslation} from "react-i18next";

interface ConfirmSendMessagePopupProps {
    closePopup: () => void;
}

const ConfirmSendMessagePopup: React.FC<ConfirmSendMessagePopupProps> = ({closePopup}) => {

    const {t} = useTranslation();

    return (
        <div className={styles.container}>
            <div className={styles.popup}>
                <img src={confirmIcon} alt={"confirm"}/>
                <h3 className={styles.title}>{t("MessageSent")!}</h3>
                <p className={styles.description}>{t("WeHaveReceivedYourMessage")!}</p>
                <div className={styles.btnWrapper}>
                    <button onClick={closePopup} className={styles.btn}>{t("Cancel")}</button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmSendMessagePopup;